export default __webpack_public_path__ + "static/media/export.49b661da.svg";